export default "__VITE_PUBLIC_ASSET__e9388d83__"